// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ChangeListSvg from '@rsuite/icon-font/lib/file/ChangeList';
var ChangeList = createSvgIcon({
  as: ChangeListSvg,
  ariaLabel: 'change list',
  category: 'file',
  displayName: 'ChangeList'
});
export default ChangeList;